/* eslint-disable react-hooks/rules-of-hooks */

import React from 'react';
import { getEnv, navigate } from '@/common/agents';
import { defineNextPage } from '@/common/next';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import useDisableWheelZoom from '$/hooks/useDisableWheelZoom';
import { isMobile } from '$/utils';
import RightHeader from '../ai_flow/components/RightHeader';
import { withFlowgramEditorStyles } from '@/utils/flowgramFlowDynamicImport';

const RoboneoFlowShare = dynamic(
  () => withFlowgramEditorStyles(() => import('$/pages/RoboneoFlowShare')),
  { ssr: false },
);

export default defineNextPage<{
  title: string;
}>({
  pageConfig: {
    projectId: '/--roboneo',
    layoutId: 'RoboneoLayout',
    renderHead({ pageProps }) {
      return (
        <Head>
          <title>RoboNeo</title>
        </Head>
      );
    },
  },
  component: (() => {
    useDisableWheelZoom();

    const onCopyMyProject = (room_id: string, code: string) => {
      navigate({
        mode: 'url',
        url: getEnv().ENV === 'development' ? '/--roboneo/ai_flow' : '/ai_flow',
        query: {
          room_id,
          code,
        },
      });
    };
    return (
      <>
        <RoboneoFlowShare onCopyMyProject={onCopyMyProject} />
        {!isMobile() && <RightHeader />}
      </>
    );
  }),
});
